<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>
                Assign Tag To Contact Data
                {{ campaignName != null ? campaignName : "" }}
              </h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>

          <div class="vx-row">
            <div class="m-5">
              <h6>Choose Tag :</h6>
            </div>

            <ul class="vertical-align">


<vs-row vs-w="12" class="pb-5 pl-5">
            <vs-col
              vs-type="flex"
              vs-lg="4"
              vs-sm="4"
              vs-xs="12"
              v-for="v in all_contact_tags" class="p-1"
            >

                <vs-checkbox v-model="selected_tag" :vs-value="v.id">{{
                  v.tag
                }}</vs-checkbox>
           
            </vs-col>
            </vs-row>



             
            </ul>
           

             
          </div>
          <div class="centerx">
                        <vs-button @click.prevent="updateTagToSDContact">Submit</vs-button>

            <span class="text-danger text-sm">{{ please_choose_tag }}</span>
          </div>
          <div>
            <DataGrid :context="'SDQCTagContact'" 
              @sendSelectionToActualPage="sendSelectionToActualPage"
              ref="SDQCTagContact"
              :columnDefs="contactsColumnDefs"
              :rowData="contactRecords"
              :dataSource="contactDataSource"
              :rowSelection="'multiple'"
            >
            </DataGrid>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
import _ from "lodash";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import ContactAutocomplete from "@/components/autocomplete/ContactsAutocomplete.vue";
import moduleTagManagement from "@/store/tag-management/moduleTagManagement.js";
export default {
  beforeMount() {
    this.getContactDataSource();
  },
  data() {
    return {
      authorized:true,
      please_choose_tag: null,
      all_contact_tags: [],

      showCampaignSelection: true,
      showDatagrid: false,
      contactsColumnDefs: [],
      selected_campaign: null,
      contactDataSource: {},
      contactRecords: [],
      campaignId: null,
      campaignName: null,
      selected_table_ids: [],
      selected_sales_developer_id: null,
      selected_tag: []
    };
  },
  components: {
    "v-select": vSelect,
    DataGrid,
    ContactAutocomplete,
    CampaignAutocomplete,
    moduleTagManagement
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }
    if (!moduleTagManagement.isRegistered) {
      this.$store.registerModule("TagsManagement", moduleTagManagement);
      moduleTagManagement.isRegistered = true;
    }

    this.campaignName = atob(this.$route.params.campaignName);

    this.checkSalesDeveloperCampaignPermission()

  },
  mounted() {
    if(this.authorized){
      this.fetchAllTagsWithSalesDeveloperId();

    }

  },
  watch: {},
  methods: {
    checkSalesDeveloperCampaignPermission() {
      let data = {}
      data.campaign_id = this.$route.params.campaignId;
      data.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/checkSalesDeveloperCampaignPermission" , data)
        .then(res => {
          let result = res.data
          if (!result){
            this.authorized = false
            this.$router.replace("/unauthorized")
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    fetchAllTagsWithSalesDeveloperId() {
      this.$store
        .dispatch(
          "TagsManagement/fetchAllTagsWithSalesDeveloperId",
          this.user_id
        )
        .then(res => {
          let result = res.data;
          result = result.filter(ele => ele.type == "contact");
          this.all_contact_tags = result;
          console.log(this.all_contact_tags);
        })
        .catch(err => {
          console.error(err);
        });
    },
    sendSelectionToActualPage(items) {
      let selected_table_ids = [];
      items.forEach(element => {

      console.log(element);
        selected_table_ids.push(element.data.table_id);
      });

      this.selected_table_ids = selected_table_ids;
    },
    updateTagToSDContact() {
      let self = this;
      let data = {};
      data.table_ids = self.selected_table_ids;
      data.selected_tag_ids = self.selected_tag;
      data.campaign_id = self.$route.params.campaignId;
      data.campaign_name = self.campaignName;
      data.sales_developer_id = self.user_id;
      data.level = "contact";

      if (data.selected_tag_ids.length == 0) {
        self.please_choose_tag = "Please select tag to update";
      }

      if (
        self.selected_table_ids.length != 0 &&
        self.$route.params.campaignId != null
      ) {
        self.$store
          .dispatch("campaignsManagement/updateTagToSDContact", data)
          .then(res => {
            if (res) {
              if (res.data.status == "success") {
                self.$refs.SDQCTagContact.gridApi.deselectAll();

                self.selected_table_ids = [];
                self.selected_tag = [];

                self.please_choose_tag = null

                self.$refs.SDQCTagContact.gridApi.refreshServerSide({purge : true});
                self.getContactDataSource();

                self.$refs.SDQCTagContact.gridApi.refreshServerSide({purge : true});

              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    goBack: function() {
      this.$router.go(-1);
    },
    getContactDataSource() {
      var self = this;
      self.contactDataSource = {
        getRows(params) {
          params.request.campaignId = self.$route.params.campaignId;
          params.request.campaignName = atob(self.$route.params.campaignName);
          params.request.sales_developer_id = self.user_id
          params.request.all_sales_developer = 'No'

          self.$store
            .dispatch("accountsManagement/fetchAllSDQCContacts", params.request)
            .then(function(response) {
              let response_data = response.rows;

              response_data.forEach(function (ele) {




if(ele._0c483105_8807_4d68_8299_91f449e7085a){

  if (ele._0c483105_8807_4d68_8299_91f449e7085a.length == 0) {
  ele._0c483105_8807_4d68_8299_91f449e7085a = "";
} else if (ele._0c483105_8807_4d68_8299_91f449e7085a.length > 1) {
  ele._0c483105_8807_4d68_8299_91f449e7085a = "ΞΞ";
} else {
  ele._0c483105_8807_4d68_8299_91f449e7085a = ele._0c483105_8807_4d68_8299_91f449e7085a[0].ddi_phone_code + ele._0c483105_8807_4d68_8299_91f449e7085a[0].ddi;
}

}


if(ele._f045b88c_3b21_4a30_9576_f566641e3447){

if (ele._f045b88c_3b21_4a30_9576_f566641e3447.length == 0) {
  ele._f045b88c_3b21_4a30_9576_f566641e3447 = "";
} else if (ele._f045b88c_3b21_4a30_9576_f566641e3447.length > 1) {
  ele._f045b88c_3b21_4a30_9576_f566641e3447 = "ΞΞ";
} else {
  ele._f045b88c_3b21_4a30_9576_f566641e3447 = ele._f045b88c_3b21_4a30_9576_f566641e3447[0].mobile_phone_code + ele._f045b88c_3b21_4a30_9576_f566641e3447[0].mobile;
}
}

if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849) {

                      let all_social_medias = ele._2619e88b_cc7c_48bd_8934_de7113d6b849

                    if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849.length == 0) {
                      ele._2619e88b_cc7c_48bd_8934_de7113d6b849 = ''
                    } else if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849.length > 1) {
                      ele._2619e88b_cc7c_48bd_8934_de7113d6b849 = 'ΞΞ'
                      ele._053ef7ea_b2ed_4110_8318_76d7e8268526 = all_social_medias[0].summary;

                    } else {
                      ele._2619e88b_cc7c_48bd_8934_de7113d6b849 = ele._2619e88b_cc7c_48bd_8934_de7113d6b849[0].social_media
                        ele._053ef7ea_b2ed_4110_8318_76d7e8268526 = all_social_medias[0].summary;

                    }
                  }


if(ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d){

  if (ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d.length == 0) {
    ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d = "";
  } else if (ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d.length > 1) {
    ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d = "ΞΞ";
  } else {
    ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d = ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d[0].email;
  }
}
});




              // response_data.forEach(function(ele) {
              //   if (ele.contact_social_media.length == 0) {
              //     ele.social_media = "";
              //   } else if (ele.contact_social_media.length > 1) {
              //     ele.social_media = "ΞΞ";
              //   } else {
              //     ele.social_media = ele.contact_social_media[0].social_media;
              //   }
              // });

              // response_data.forEach(function(ele) {
              //   if (ele.contact_email.length == 0) {
              //     ele.email = "";
              //   } else if (ele.contact_email.length > 1) {
              //     ele.email = "ΞΞ";
              //   } else {
              //     ele.email = ele.contact_email[0].email;
              //   }
              // });

              // response_data.forEach(function(ele) {
              //   if (ele.contact_web) {
              //     if (ele.contact_web.length == 0) {
              //       ele.website = "";
              //     } else if (ele.contact_web.length > 1) {
              //       ele.website = "ΞΞ";
              //     } else {
              //       ele.website = ele.contact_web[0].url;
              //     }
              //   }
              // });

              // response_data.forEach(function(ele) {
              //   if (ele.contact_linkedin) {
              //     if (ele.contact_linkedin.length == 0) {
              //       ele.linkedin = "";
              //     } else if (ele.contact_linkedin.length > 1) {
              //       ele.linkedin = "ΞΞ";
              //     } else {
              //       ele.linkedin = ele.contact_linkedin[0].url;
              //     }
              //   }
              // });

              // response_data.forEach(function(ele) {
              //   if (ele.contact_phone) {
              //     if (ele.contact_phone.length == 0) {
              //       ele.phone = "";
              //     } else if (ele.contact_phone.length > 1) {
              //       ele.phone = "ΞΞ";
              //     } else {
              //       ele.phone = ele.contact_phone[0].phone_no;
              //     }
              //   }
              // });
              if (response_data.length != 0) {
                self.$refs.SDQCTagContact.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.SDQCTagContact.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getSDContactColumns() {
      let self = this;

      self.$store
        .dispatch(
          'campaignsManagement/getAllContactSelectedCampaignColumns',
          self.$route.params.campaignId
        )
        .then(res => {

          let contact_columns = JSON.parse(res.data);


          contact_columns = contact_columns.filter(function(ele) {
            return ele.identifier != 'mobile_phone_code' && ele.identifier != 'ddi_phone_code' && ele.identifier != 'ddi' && ele.identifier != 'mobile' && ele.identifier != 'contact_status' && ele.identifier != 'contact_status_notes' && ele.identifier != 'grade'   
            });


            



            var index = 1;
            contact_columns.forEach(function(ele) {

              


              ele.id = ele.uuid

          

          
              ele.headerName = ele.name;

              ele.field = '_' + ele.id.replaceAll("-", "_");

              if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }


                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


            this.contactsColumnDefs = contact_columns


            let actions = {
            headerName: "Actions",
            field: "transactions",
            cellRenderer: "CellRendererActions",
            suppressHeaderMenuButton: true,
            checkboxSelection: true,

            pinned: true,
            width: 50
          };

          this.contactsColumnDefs.push(actions)

          let contact_status = {
        column_name: "contact_status",
        field: "contact_status",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        headerName: "Contact Status"
      };

      this.contactsColumnDefs.push(contact_status);


      let contact_status_notes = {
        column_name: "contact_status_notes",
        field: "contact_status_notes",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        headerName: "Contact Status Notes"
      };

      this.contactsColumnDefs.push(contact_status_notes);

      let grade = {
        column_name: "grade",
        field: "grade",
        filter: "agNumberColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        headerName: "Grade"
      };

      this.contactsColumnDefs.push(grade);


        })
        .catch(err => {
          console.log(err)
        })
     
    }
  },
  beforeMount() {
    this.getSDContactColumns();
    this.getContactDataSource();
    this.$refs.SDQCTagContact.gridApi.showNoRowsOverlay();
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}

.vertical-align {
  display: flex;
  justify-content: center; /* align horizontal */
  align-items: center; /* align vertical */
  /* width: 800px; */
}
</style>
